// THIS CODE WAS AUTO-GENERATED from '/packages/icon/src/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props}>
    <path
      fillRule="evenodd"
      d="M12.05 2.48c5.5 0 10 3.6 10 8.1a7.38 7.38 0 0 1-2.1 5 30.86 30.86 0 0 1-7.9 5.8c-1 .4-.9-.2-.9-.5l.1-.9c0-.3.1-.7 0-.9s-.6-.4-.9-.5c-4.8-.6-8.4-4-8.4-8 .1-4.5 4.6-8.1 10.1-8.1Zm-3.7 9.6h-1.9v-3.5c0-.1-.1-.1-.2-.1h-.7c-.1 0-.2 0-.2.1V13c0 .1 0 .1.1.1l.1.1h2.8a.22.22 0 0 0 .2-.2v-.7a.23.23 0 0 0-.2-.22Zm1-3.6h.7a.22.22 0 0 1 .2.2v4.4a.22.22 0 0 1-.2.2h-.7a.22.22 0 0 1-.2-.2v-4.5c0-.1.1-.1.2-.1Zm4.8 0h.7c.1 0 .2 0 .2.1V13a.22.22 0 0 1-.2.2H14l-2-2.7v2.6a.22.22 0 0 1-.2.2h-.7a.22.22 0 0 1-.2-.2V8.58c0-.1.1-.1.2-.1h.7l2 2.7v-2.6a.74.74 0 0 1 .35-.1Zm4.8.8c0 .2-.1.2-.2.2h-1.9v.7h1.9a.22.22 0 0 1 .2.2v.7a.22.22 0 0 1-.2.2h-1.9V12h1.9a.22.22 0 0 1 .2.2v.7a.22.22 0 0 1-.2.2H16c-.1 0-.1 0-.1-.1l-.1-.1V8.58c0-.1 0-.1.1-.1l.1-.1h2.8a.22.22 0 0 1 .2.2Z"
    />
  </BaseIcon>
)
